module.exports = __webpack_public_path__ + "img/cooperative0_logo28.458469cb.jpg";